export const userRoles = {
  SYSTEM_ADMIN: 1,
  COMPANY_ADMIN: 2,
  RECEPTION_ADMIN: 3,
  HR_ADMIN: 4,
  USER: 5,
  OFFICE_ADMIN: 6,
};
